const SmallOrderMindmapManage = () => import('@/views/main/promotion/smallOrderMindmapManage/SmallOrderMindmapManage.vue')
export default {
  path: '/main/promotion/smallOrder/mindmapManage',
  name: 'SmallOrderMindmapManage',
  component: SmallOrderMindmapManage,
  children: []
}
